var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hb-link',{attrs:{"color":"secondary"},on:{"click":function($event){return _vm.btnClickedHandler(_vm.params, 'event')}}},[_vm._v(" View ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }